import React, { ReactFragment, useEffect, useState } from "react";

import Panel from "../../../ui/Panel/Panel";
import { FormattedMessage } from "react-intl";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";

import { IReportStepTwoProps } from "./module/constants";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { push } from "connected-react-router";

import classes from "./ReportStepTwo.module.scss";

import messages from "./module/messages";

import { ROUTES } from "../../../module/constants";

import { resetPerimeters } from "../../CreateCertifaction/module/actions";
import {
  selectSelectedReport,
  selectReports,
  selectReportValue,
  selectResponseState,
} from "../module/selectors";
import { reportGenerate, reportResetState } from "../module/actions";
import ReportTextField from "../ReportTextField";
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal";
import ResponseModal from "../../../components/Modals/ResponseModal/ResponseModal";
import ReportAutocompleteField from "../ReportAutocompleteField";

const ReportStepTwo = (props: IReportStepTwoProps) => {
  const {
    selectedReport,
    reportsManagedLoader,
    changeLocation,
    resetPerimeters,
    initialState,
    reportGeneration,
    selectReports,
    value,
    callState,
    resetReportState,
  } = props;

  const [isPossibleToContinue, setIsPossibleToContinue] =
    useState<boolean>(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);

  const renderLabel = () => {
    let i = 1 as number;
    let tempArray = [] as ReactFragment[];
    if (
      selectedReportFull.parameters &&
      selectedReportFull.parameters.length > 0
    ) {
      selectedReportFull.parameters.forEach((parameter: any) => {
        if (parameter.enrichments.length > 0) {
          parameter.enrichments.forEach(
            (enrichment: { property: string; value: string }) => {
              if (enrichment.property === "VALUES") {
                tempArray.push(
                  <div className={classes["input-wrapper"]} key={i}>
                    <ReportAutocompleteField
                      id={i}
                      label={enrichment.value}
                      parameter={parameter.parameter}
                      listType={enrichment.value}
                      property={enrichment.property}
                    />
                  </div>
                );
              } else {
                tempArray.push(
                  <div className={classes["input-wrapper"]} key={i}>
                    <ReportTextField
                      id={i}
                      label={enrichment.value}
                      initialValue={""}
                      parameter={parameter.parameter}
                      property={enrichment.property}
                    />
                  </div>
                );
              }
            }
          );
        } else {
          tempArray.push(
            <div className={classes["input-wrapper"]} key={i}>
              <ReportTextField
                id={i}
                label={parameter.parameter}
                initialValue={""}
                parameter={parameter.parameter}
                property={parameter.parameter}
              />
            </div>
          );
        }
        i++;
      });
      return <div style={{ width: "50%" }}>{tempArray}</div>;
    } else {
      return null;
    }
  };

  useEffect(() => {
    let i = false;
    value.forEach((tempValue: any) => {
      if (!tempValue.value) {
        i = true;
      }
    });
    setIsPossibleToContinue(i);
  }, [value]);

  useEffect(() => {
    let reportId: any[] = [];
    if (selectedReport) reportId.push(selectedReport.id);
  }, []);

  useEffect(() => {
    resetPerimeters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const [selectedReportFull, setSelectedReportFull] = useState<any>({});

  useEffect(() => {
    setSelectedReportFull(
      selectReports.filter(
        (report: any) => report.report.id === selectedReport.id
      )[0]
    );
  }, [selectedReport, selectReports]);

  const onSubmit = () => {
    setShowConfirmModal(true);
  };

  useEffect(() => {
    resetReportState();
  }, []);

  const confirmConfirmModalHandler = () => {
    setShowConfirmModal(false);
    setShowResponseModal(true);
    let tempBody: any = {};
    value.forEach((tempValue: any) => {
      const parameterName: string = tempValue.parameter;
      tempBody[parameterName] = tempValue.value;
    });
    let payload: any = {
      reportId: selectedReportFull.report.id,
      body: tempBody,
    };
    reportGeneration(payload);
  };

  const closeResponseModaleHandler = () => {
    setShowResponseModal(false);
    changeLocation(ROUTES.REPORT);
  };

  return (
    <>
      <ConfirmModal
        show={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={confirmConfirmModalHandler}
      />
      <ResponseModal
        show={showResponseModal}
        onClose={closeResponseModaleHandler}
        state={callState}
      />
      <div>
        <div className={classes["cta_wrapper"]}>
          <OutlinedButton onClick={() => changeLocation(ROUTES.REPORT)}>
            <FormattedMessage {...messages.CTABack} />
          </OutlinedButton>

          <OutlinedButton
            disabled={isPossibleToContinue}
            onClick={() => onSubmit()}
          >
            <FormattedMessage {...messages.Generate} />
          </OutlinedButton>
        </div>
        <div className={classes["text-title"]}>
          <div>{`Report: ${initialState.name} [${initialState.id}]`}</div>
        </div>
        <div className={classes["create-certification-input-wrapper"]}>
          {renderLabel()}
        </div>
        {}

        <Panel
          title={
            <FormattedMessage
              {...messages.PanelDetailRequestLabelDescription}
            />
          }
          loader={reportsManagedLoader}
        >
          <div>{initialState.description}</div>
        </Panel>
        <div className={classes["actions_top"]}>
          <OutlinedButton onClick={() => changeLocation(ROUTES.REPORT)}>
            <FormattedMessage {...messages.CTABack} />
          </OutlinedButton>
        </div>
      </div>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    initialState: selectSelectedReport,
    selectReports: selectReports,
    selectedReport: selectSelectedReport,
    value: selectReportValue,
    callState: selectResponseState,
  });

const mapDispatchToProps: any = {
  reportGeneration: (payload: any) => reportGenerate(payload),
  changeLocation: (url: string) => push(url),
  resetReportState: () => reportResetState(),
  resetPerimeters,
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(ReportStepTwo);
